import { connect } from "react-redux";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import * as selectors from "./selectors/rlab-selectors";

export class Rlab extends Component {
  static defaultProps = {
    components: {}
  };

  static propTypes = {
    variant: PropTypes.string,
    components: PropTypes.object.isRequired
  };

  render() {
    const { variant, components } = this.props;

    // List provided variant keys
    const variants = Object.keys(components);
    if (variants.length === 0) {
      return <Fragment />;
    }

    // Determine default component to serve
    const defaultComponent = components[variants[0]];

    return components[variant] || defaultComponent;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    variant: selectors.getVariant(state, ownProps.campaignCode)
  };
};

export default connect(
  mapStateToProps,
  () => ({}),
)(Rlab);
